"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.busCfgCombobox = busCfgCombobox;
exports.busCfgPage = busCfgPage;
exports.obj_storage_type = exports.cfg_cons = void 0;
exports.querySsoCfg = querySsoCfg;
exports.queryStorageCfg = queryStorageCfg;
exports.saveCfg = saveCfg;
exports.sso_type = void 0;
exports.updateCfg = updateCfg;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var cfg_cons = exports.cfg_cons = {
  "cus_cfg": "自定义配置",
  "oss_cfg": "对象存储配置",
  "sso_cfg": "单点登录配置"
};
var obj_storage_type = exports.obj_storage_type = [{
  code: 'oss',
  desc: '阿里云'
}, {
  code: 'tos',
  desc: '火山云'
}, {
  code: 'obs',
  desc: '华为云'
}, {
  code: 'cos',
  desc: '腾讯云'
}];
var sso_type = exports.sso_type = [{
  code: 'wx_work',
  desc: '企业微信'
}, {
  code: 'ding_talk',
  desc: '钉钉'
}, {
  code: 'lark',
  desc: '飞书'
}];

// 获取配置常量
function busCfgCombobox() {
  return (0, _requestPIM.default)({
    url: "/busCfg/combobox",
    method: "get"
  });
}
function busCfgPage(query) {
  return (0, _requestPIM.default)({
    url: "/busCfg/page",
    method: "get",
    params: query
  });
}
// 新增渠道
function saveCfg(data) {
  return (0, _requestPIM.default)({
    url: '/busCfg',
    method: 'post',
    data: data
  });
}
// 编辑渠道
function updateCfg(data) {
  return (0, _requestPIM.default)({
    url: '/busCfg',
    method: 'put',
    data: data
  });
}

// 查询对象存储配置
function queryStorageCfg() {
  return (0, _requestPIM.default)({
    url: '/busCfg/storageCfg',
    method: 'get'
  });
}

//查询单点登录配置
function querySsoCfg() {
  return (0, _requestPIM.default)({
    url: '/busCfg/ssoCfg',
    method: 'get'
  });
}